import { ENVIRONMENT, FRONTEND_ROOT } from "config/constants";

export default function generateRelativeHref(url) {
  return url.replace(
    ENVIRONMENT === "uat" ? "https://www.axios.com" : FRONTEND_ROOT,
    ""
  );
}
